import PiwikPro, {
  CustomEvent,
  ErrorTracking,
  PageViews,
  UserManagement,
} from '@piwikpro/tracking-base-library';
import type { DependencyContainer } from 'tsyringe';
import { PageEventBusService } from '@gen-epix/ui-client-common/classes/services/PageEventBusService';

import { NonceUtil } from '../NonceUtil';
import { EnvironmentSettingsService } from '../../services/EnvironmentSettingsService';

export class PiwikProUtil {
  public static setup(dependencyContainer: DependencyContainer): void {
    const containerId = EnvironmentSettingsService.getInstance().settings.PIWIK_PRO_CONTAINER_ID;
    if (!containerId) {
      console.warn('No Piwik Pro container ID found in environment settings, skipping Piwik Pro setup.');
      return;
    }

    PiwikPro.initialize(containerId, 'https://statistiek.rijksoverheid.nl', {
      nonce: NonceUtil.getNonce(),
    });

    UserManagement.resetUserId();
    dependencyContainer.resolve(PageEventBusService).addEventListener('error', (event) => {
      ErrorTracking.trackError(event);
    });
    dependencyContainer.resolve(PageEventBusService).addEventListener('changePage', (event) => {
      PageViews.trackPageView(event.pageName);
    });
    dependencyContainer.resolve(PageEventBusService).addEventListener('changeUser', (event) => {
      UserManagement.setUserId(event.email);
    });
    dependencyContainer.resolve(PageEventBusService).addEventListener('click', (event) => {
      const category = event.page.pageName;
      const action = event.type;
      let name = event.label;
      if (event.context) {
        name = `${name} (${event.context})`;
      }
      CustomEvent.trackEvent(category, action, name);
    });
  }
}
